export default "__VITE_PUBLIC_ASSET__ff881d5e__"